<template>
  <validable-form @submit="submit">
    <modal background>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ edit ? "Edytuj kontakt alarmowy" : "Dodaj kontakt alarmowy" }}
          </p>
          <button
            class="delete"
            type="submit"
            aria-label="close"
            @click="cancel"
          ></button>
        </header>

        <section class="modal-card-body">
          <div class="form">
            <label class="label">Numer telefonu</label>
            <div class="field">
              <div class="control has-icons has-icons-left">
                <control-input
                  rules="required"
                  type="text"
                  placeholder="123 456 789"
                  v-model.trim="contact.phone"
                />
                <icon class="is-small is-left" name="fa-phone-alt" />
              </div>
            </div>

            <label class="label">Dostępność</label>
            <div
              class="field has-addons"
              v-for="(availability, index) in contact.availability"
              :key="`availability${index}`"
            >
              <control-editor
                frame
                ref="availability"
                class="editor"
                rules="required"
                type="text"
                placeholder="Poniedziałek..."
                v-model="contact.availability[index]"
              />

              <div class="delete" @click="removeAvailability(index)" />
            </div>

            <div class="field is-pulled-right">
              <button
                type="button"
                class="button is-primary"
                @click="addAvailability"
              >
                <icon name="fa-plus" />
              </button>
            </div>
          </div>
        </section>

        <footer class="modal-card-foot">
          <button class="button is-success" type="submit">
            <icon name="fa-check" />
            <span>Akceptuj</span>
          </button>
          <button class="button" type="button" @click="cancel">Anuluj</button>
        </footer>
      </div>
    </modal>
  </validable-form>
</template>

<script>
import { Modal } from "%modals";
import { Icon, ValidableForm, ControlInput } from "%helpers";
import ControlEditor from "%admin/components/global/ControlEditor";

export default {
  name: "breakdown-modal",

  components: {
    Modal,
    Icon,
    ValidableForm,
    ControlInput,
    ControlEditor
  },

  props: {
    value: {
      type: Object,
      default: () => ({
        phone: "",
        availability: []
      })
    },

    onSave: Function,

    edit: Boolean
  },

  data() {
    return {
      contact: {
        phone: "",
        availability: []
      }
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.contact = {
        ...this.value,
        availability: [...this.value.availability]
      };
    },

    async addAvailability() {
      this.contact.availability.push("");
    },

    removeAvailability(index) {
      this.contact.availability.splice(index, 1);
    },

    submit() {
      this.onSave(this.contact);
      this.cancel();
    },

    cancel() {
      this.$emit("hide");
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  padding-bottom: 1rem;
}

.editor {
  width: 100%;
  margin-right: 1rem;
}
</style>
